/* Chování Moon PDP — přesně jak v předloze. Do theme jako assets/moon-page.js (defer). */
/* Scroll-swap fotky: bez brýlí → s brýlemi, když horní hrana fotky přejde
   40 % výšky okna. Obousměrně, stejně jako na back-to-school (bts.js). */
(function () {
  document.querySelectorAll('[data-kl-swap]').forEach(function (img) {
    var on = img.getAttribute('data-kl-swap-src');
    var off = img.getAttribute('src');
    if (!on || !off) return;
    var pre = new Image(); pre.src = on;
    function update() {
      var next = img.getBoundingClientRect().top < window.innerHeight * 0.4 ? on : off;
      if (img.getAttribute('src') !== next) img.src = next;
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
  /* Prolnutí dvou úhlů hodinek — stejný trigger, ale crossfade místo výměny src. */
  document.querySelectorAll('[data-kl-fade]').forEach(function (box) {
    function update() {
      box.classList.toggle('is-alt', box.getBoundingClientRect().top < window.innerHeight * 0.4);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

(function () {
  /* Datum doručení se dopočítá z reálného dneška — nikdy nezastará. */
  var months = ['ledna','února','března','dubna','května','června','července','srpna','září','října','listopadu','prosince'];
  var d = new Date(), left = 2;
  while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) left--; }
  var eta = document.getElementById('kl-eta');
  if (eta) eta.textContent = d.getDate() + '. ' + months[d.getMonth()];
})();

(function () {
  var wrap = document.querySelector('[data-kl-jumpnav-wrap]');
  var nav = document.querySelector('[data-kl-jumpnav], .kl-jumpnav');
  var slot = document.querySelector('[data-kl-jumpnav-slot]');
  if (!nav) return;

  var links = Array.prototype.slice.call(nav.querySelectorAll('.kl-jumpnav__link'));
  var pill = nav.querySelector('[data-kl-jumpnav-pill]');
  var pillLabel = nav.querySelector('[data-kl-jumpnav-pill-label]');
  var sentinel = (wrap && wrap.querySelector('[data-kl-jumpnav-sentinel]')) || null;
  var mqDesktop = window.matchMedia('(min-width: 769px)');
  var targets = [];
  var stuck = false;
  var engaged = false;
  /* Mobil: odlepit Engaged jen po tom, co sentinel nejdřív opustil viewport
     (jinak klik z menu hned odlepí — sentinel je ještě vidět). */
  var engagedAway = false;
  /* Výška slotu = plný seznam, ať Engaged neposune kotvy pod jumpnavem. */
  var engagedSpacerH = 0;

  function stickyHeaderOffset() {
    /* Nová hlavička (.hp-nav) první — stará sections/header.liquid je od
       nasazení HP v12 vypnutá, takže by se tu nenašla a jumpnav by se lepil
       na horní hranu pod ni. Měří se přes getBoundingClientRect, takže se
       samo ošetří i stav, kdy hlavička odjela nahoru (is-away): bottom je
       pak <= 0 a offset vyjde 0, přesně jak má. */
    var section = document.querySelector('.hp-nav')
      || document.querySelector('#shopify-section-header')
      || document.querySelector('.section-header');
    if (!section) return 0;
    if (section.classList.contains('shopify-section-header-hidden')) return 0;
    var r = section.getBoundingClientRect();
    if (r.bottom <= 0 || r.top > 2) return 0;
    return Math.round(r.bottom);
  }

  function applyTop() {
    nav.style.setProperty('--kl-jumpnav-top', stickyHeaderOffset() + 'px');
  }

  function setActive(id) {
    var active = null;
    links.forEach(function (a) {
      var on = (a.getAttribute('href') || '') === '#' + id;
      a.classList.toggle('is-active', on);
      if (on) active = a;
    });
    if (active && pillLabel) {
      var lab = active.querySelector('.kl-jumpnav__label');
      pillLabel.textContent = (lab ? lab.textContent : active.textContent).trim();
    }
  }

  function closeMenu() {
    nav.classList.remove('is-open');
    if (pill) pill.setAttribute('aria-expanded', 'false');
    if (slot && stuck && engagedSpacerH) slot.style.height = engagedSpacerH + 'px';
  }

  function setStuck(next, opts) {
    opts = opts || {};
    if (next === stuck) {
      if (stuck) {
        applyTop();
        if (slot && engaged && engagedSpacerH) slot.style.height = engagedSpacerH + 'px';
        else if (slot) slot.style.height = nav.offsetHeight + 'px';
      }
      return;
    }
    stuck = next;
    if (stuck) {
      nav.classList.add('is-stuck');
      if (opts.mobileCompact) {
        nav.classList.add('is-compact');
        if (pill) pill.hidden = false;
      } else {
        nav.classList.remove('is-compact');
        if (pill) pill.hidden = true;
      }
      if (slot) {
        slot.style.height = (opts.spacerH || nav.offsetHeight) + 'px';
      }
      applyTop();
    } else {
      engaged = false;
      engagedAway = false;
      engagedSpacerH = 0;
      nav.classList.remove('is-stuck', 'is-compact', 'is-open');
      if (slot) slot.style.height = '';
      if (pill) {
        pill.hidden = true;
        pill.setAttribute('aria-expanded', 'false');
      }
      if (!mqDesktop.matches) nav.style.removeProperty('--kl-jumpnav-top');
    }
  }

  function enterEngaged() {
    /* Nejdřív změřit plný seznam, pak teprve compact — jinak se posunou všechny kotvy. */
    var spacerH = nav.offsetHeight;
    engaged = true;
    engagedAway = false;
    engagedSpacerH = spacerH;
    setStuck(true, { mobileCompact: true, spacerH: spacerH });
  }

  function updateDesktopStuck() {
    if (!mqDesktop.matches) return;
    applyTop();
    if (!sentinel) return;
    var top = stickyHeaderOffset();
    setStuck(sentinel.getBoundingClientRect().top < top + 1, {});
  }

  function updateMobileEngaged() {
    if (mqDesktop.matches || !engaged || !sentinel) return;
    applyTop();
    var top = stickyHeaderOffset();
    var st = sentinel.getBoundingClientRect().top;
    /* Sentinel odjel nad viewport → uživatel scrolluje v obsahu */
    if (st < top - 24) engagedAway = true;
    /* Zpátky k menu: sentinel znovu pod headerem, ale jen po předchozím odjetí */
    if (engagedAway && st >= top + 8) setStuck(false);
  }

  function headingOf(section) {
    if (!section) return null;
    return section.querySelector('.kl-heading h2, .kl-heading .kl-h2, h2.kl-h2, h2, .bts-h2, .kl-h2') || section;
  }

  function scrollToTarget(section) {
    var anchor = headingOf(section) || section;
    if (!anchor) return;
    if (typeof anchor.scrollIntoView === 'function') {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* Po position:fixed prohlížeč často zruší smooth scroll ve stejném tahu —
     počkat na 2 framy (layout + paint), teprve pak skočit. */
  function afterLayout(fn) {
    requestAnimationFrame(function () {
      requestAnimationFrame(fn);
    });
  }

  links.forEach(function (a) {
    var href = a.getAttribute('href') || '';
    var id = href.charAt(0) === '#' ? href.slice(1) : '';
    var t0 = id ? document.getElementById(id) : null;
    if (t0) targets.push(t0);
    a.addEventListener('click', function (e) {
      /* Cíl vždy znovu — Judge.me aj. můžou dorazit až po init. */
      var t = id ? document.getElementById(id) : null;
      if (!t) return;
      e.preventDefault();
      setActive(t.id || id);
      closeMenu();
      if (!mqDesktop.matches) {
        var wasEngaged = engaged;
        enterEngaged();
        if (wasEngaged) {
          scrollToTarget(t);
        } else {
          afterLayout(function () { scrollToTarget(t); });
        }
      } else {
        scrollToTarget(t);
      }
    });
  });

  if (pill) {
    pill.addEventListener('click', function () {
      if (!nav.classList.contains('is-compact')) return;
      if (nav.classList.contains('is-open')) closeMenu();
      else {
        nav.classList.add('is-open');
        pill.setAttribute('aria-expanded', 'true');
        /* Picker je fixed overlay — spacer drží výšku plného seznamu */
        if (slot && engagedSpacerH) slot.style.height = engagedSpacerH + 'px';
      }
    });
    document.addEventListener('click', function (e) {
      if (!nav.classList.contains('is-open')) return;
      if (nav.contains(e.target)) return;
      closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  window.addEventListener('scroll', function () {
    if (mqDesktop.matches) updateDesktopStuck();
    else {
      if (engaged) updateMobileEngaged();
      else if (stuck) applyTop();
    }
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (mqDesktop.matches) {
      engaged = false;
      engagedAway = false;
      engagedSpacerH = 0;
      updateDesktopStuck();
    } else if (engaged) {
      /* Po otočení znovu změřit spacer z aktuálního layoutu není trivial —
         držet poslední engagedSpacerH a top. */
      if (slot && engagedSpacerH) slot.style.height = engagedSpacerH + 'px';
      applyTop();
    } else {
      setStuck(false);
    }
  }, { passive: true });

  if (mqDesktop.addEventListener) {
    mqDesktop.addEventListener('change', function () {
      engaged = false;
      engagedAway = false;
      engagedSpacerH = 0;
      setStuck(false);
      if (mqDesktop.matches) updateDesktopStuck();
    });
  }

  if (mqDesktop.matches) updateDesktopStuck();

  if ('IntersectionObserver' in window && targets.length) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (entry.target.id) setActive(entry.target.id);
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    targets.forEach(function (t) { obs.observe(t); });
  }
})();

(function () {
  var atc = document.getElementById('kl-atc');
  var bar = document.getElementById('kl-sticky-atc');
  if (atc && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      bar.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(atc);
  }

  /* Galerie: klik na náhled prohodí hlavní fotku. */
  var hero = document.getElementById('kl-hero-img');
  var heroBox = hero ? hero.parentElement : null;
  var thumbs = document.querySelectorAll('#kl-thumbs > div');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var img = t.querySelector('img');
      if (!img || !hero) return;
      hero.src = img.src; hero.alt = img.alt;
      /* Dok je na bílé — hlavní rám se přepne z krému na bílý panel. */
      if (heroBox) heroBox.classList.toggle('is-plain', t.hasAttribute('data-plain'));
      thumbs.forEach(function (o) { o.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ZÁPLATA THEME (fail-open, pravidlo z CLAUDE.md): šablona vykreslí všech šest
     karet otevřených, aby mobil bez naběhlého JS neviděl jednu funkci ze šesti
     a zbylých pět nešlo otevřít. Jakmile tenhle skript běží, sbalí všechny kromě
     první — tedy přesně stav, který má předloha. Na desktopu je to neviditelné
     (moon-page.css:341 dává is-open i bez ní stejný stín, chevron je skrytý). */
  (function () {
    var cards = document.querySelectorAll('#klFunkce .kl-fn__card');
    for (var i = 0; i < cards.length; i++) {
      var otevrena = i === 0;
      cards[i].classList.toggle('is-open', otevrena);
      var hlava = cards[i].querySelector('.kl-fn__top');
      if (hlava) hlava.setAttribute('aria-expanded', otevrena ? 'true' : 'false');
    }
  })();

  /* Funkce: na mobilu se karty rozbalují klepnutím, na desktopu je vidět vše. */
  document.querySelectorAll('#klFunkce .kl-fn__top').forEach(function (top) {
    function toggle() {
      if (window.matchMedia('(min-width:768px)').matches) return;
      var card = top.closest('.kl-fn__card');
      var open = !card.classList.contains('is-open');
      card.classList.toggle('is-open', open);
      top.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    top.addEventListener('click', toggle);
    top.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); toggle(); }
    });
  });

  /* Volba barvy: na ostré PDP jsou to dva produkty → jiná URL. Tady jen stav. */
  document.querySelectorAll('.kl-swatch').forEach(function (s) {
    s.addEventListener('click', function (ev) {
      ev.preventDefault();
      document.querySelectorAll('.kl-swatch').forEach(function (o) { o.removeAttribute('aria-current'); });
      s.setAttribute('aria-current', 'true');
      var img = s.querySelector('img');
      if (img && hero) { hero.src = img.src; if (heroBox) heroBox.classList.remove('is-plain'); }
    });
  });

  /* DOPLNĚK THEME: karusel sekce Aplikace (pět snímků aplikace).
     Staví na domácí komponentě .kl-carousel/.kl-track/.kl-dots/.kl-arrow
     (kloki-components.css §14). Posouvá nativní scroll-snap, skript jen
     dokresluje tečky a zašeďuje šipky na krajích.
     ZÁMĚRNĚ BEZ AUTOMATICKÉHO POSUNU — rozhodnutí majitele; navíc pohyb,
     který nejde zastavit, porušuje WCAG 2.2.2 (a pauza na hover ho nesplní,
     protože na mobilu hover neexistuje).
     Bez skriptu zůstane obyčejná posouvatelná řada všech pěti snímků;
     ovládání se ukáže, teprve když skript naběhne (.is-ready). */
  (function () {
    var box = document.querySelector('.kl-carousel--app');
    if (!box) return;
    var track = box.querySelector('.kl-track--app');
    var slides = [].slice.call(box.querySelectorAll('.kl-app__shot'));
    var dots = [].slice.call(box.querySelectorAll('.kl-dot'));
    var prev = box.querySelector('.kl-arrow--prev');
    var next = box.querySelector('.kl-arrow--next');
    if (!track || slides.length < 2) return;

    var klid = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var aktivni = 0;

    function jedNa(i) {
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - slides[0].offsetLeft, behavior: klid ? 'auto' : 'smooth' });
    }
    function prekresli() {
      /* Aktivní snímek se počítá z pozice scrollu — jediný zdroj pravdy,
         nezávislý na tom, jestli a jak často přijdou scroll události. */
      var x = track.scrollLeft, nula = slides[0].offsetLeft, nej = 0, nejd = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs((slides[i].offsetLeft - nula) - x);
        if (d < nejd) { nejd = d; nej = i; }
      }
      aktivni = nej;
      /* Teček je tolik, kolik je skutečných poloh. Na desktopu jsou vidět
         tři snímky najednou, takže poslední dvě polohy neexistují — bez
         tohohle by dvě tečky nikdy nesvítily a vypadaly by rozbitě. */
      var konec = track.scrollWidth - track.clientWidth, posl = 0, pd = Infinity;
      for (var k = 0; k < slides.length; k++) {
        var kd = Math.abs((slides[k].offsetLeft - nula) - konec);
        if (kd < pd) { pd = kd; posl = k; }
      }
      for (var n = 0; n < dots.length; n++) {
        dots[n].hidden = n > posl;
        dots[n].setAttribute('aria-current', n === aktivni ? 'true' : 'false');
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    track.addEventListener('scroll', prekresli, { passive: true });
    window.addEventListener('resize', prekresli);
    /* Překreslí i při změně rozložení bez scrollu (načtení obrázků, font). */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(prekresli, { root: track, threshold: 0.75 });
      slides.forEach(function (s) { io.observe(s); });
    }

    dots.forEach(function (d, n) { d.addEventListener('click', function () { jedNa(n); }); });
    if (prev) prev.addEventListener('click', function () { jedNa(Math.max(0, aktivni - 1)); });
    if (next) next.addEventListener('click', function () { jedNa(Math.min(slides.length - 1, aktivni + 1)); });

    box.classList.add('is-ready');
    prekresli();
  })();

  /* Barvy a doplňky: swipe carousel. Čas mění ÚHEL aktivního snímku,
     swipe/klik na tečku mění VARIANTU. */
  (function () {
    var track = document.getElementById('klBarvyTrack');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('.kl-carousel__slide'));
    var dots = [].slice.call(document.querySelectorAll('#klBarvyDots button[data-go]'));
    var caption = document.getElementById('klBarvyCaption');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var active = 0, altTimer = null, tick = null;

    function restartAlt() {
      clearInterval(altTimer);
      if (reduce) return;
      altTimer = setInterval(function () {
        if (document.hidden) return;
        var s = slides[active];
        if (s) s.classList.toggle('is-alt');
      }, 3200);
    }
    function setActive(i) {
      if (i === active) return;
      active = i;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        if (n !== i) s.classList.remove('is-alt');
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (caption) caption.textContent = slides[i].dataset.label || '';
      restartAlt();
    }
    function center(i) {
      var s = slides[i];
      if (s) track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
    }
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
        slides.forEach(function (s, n) {
          var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
          if (d < bd) { bd = d; best = n; }
        });
        setActive(best);
      }, 70);
    }, { passive: true });

    dots.forEach(function (d) { d.addEventListener('click', function () { center(+d.dataset.go); }); });

    /* Myší tažení — na mobilu stačí nativní swipe. */
    var down = false, sx = 0, sl = 0, dragged = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; dragged = false; sx = e.clientX; sl = track.scrollLeft;
      track.classList.add('is-dragging');
      if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 4) dragged = true;
      track.scrollLeft = sl - dx;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      if (dragged) center(active);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    slides.forEach(function (s, i) {
      s.addEventListener('click', function () {
        if (dragged) { dragged = false; return; }
        if (i === active) { s.classList.toggle('is-alt'); restartAlt(); return; }
        center(i);
      });
    });
    restartAlt();
  })();
})();